import React from 'react';
import NavigationContainer from 'Components/ComponentLibrary/Organisms/Navigation/Container';
import PropTypes from 'prop-types';

const Navigation = ({
  className,
  collection,
  isInitializing,
  loadingError,
  open,
}) => (
  <NavigationContainer
    className={className}
    collection={collection}
    isInitializing={isInitializing}
    loadingError={loadingError}
    open={open}
  />
);

Navigation.defaultProps = {
  className: '',
  isInitializing: false,
  loadingError: undefined,
  open: false,
  collection: null,
};

Navigation.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.object,
  isInitializing: PropTypes.bool,
  loadingError: PropTypes.object,
  open: PropTypes.bool,
};

export default Navigation;
